/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, themeV2, coloredScrollBar } from '@insticator/insticator-ui';



/* ++++++++++ --------------- LINE CHART : STYLES --------------- ++++++++++ */
export default {
	linechart: {
        minWidth: '500px',
        overflowX: 'auto',
        overflowY: 'hidden',
        paddingBottom: pxToEm(6),
		marginTop: pxToEm(16),
        marginBottom: pxToEm(16),
        marginRight: pxToEm(50),
		height: pxToEm(300),
		'& > div': {
			height: `${pxToEm(300)} !important`
		},
    extend: coloredScrollBar(themeV2.color.base.scrollbar)
	}
};
